import React, { Component } from 'react';
import { switcherrateyear } from '../helpers/Lists.js';

interface IProps {
    label?: any;
    selectedswitcherrateyear?: string;
    classes?: string;
    onChange(v: any): void;
    onBlur?(): void;
}

export class SwitcherRateYearSelect extends Component<IProps, any> {
    render() {
        return (
            <div className='grid justify-c'>
                {this.props.label &&
                <label htmlFor='switcherrateyear'>{this.props.label}</label>
                }
                <select name="switcherrateyear" id="switcherrateyear" aria-required="true" aria-invalid="false" 
                    className={this.props.classes ?? ''}
                    onChange={this.props.onChange}
                    onBlur={() => {if (this.props.onBlur) this.props.onBlur();}}>
                    <option key={'currentlendertopup-select'}  value="" selected={!this.props.selectedswitcherrateyear} className="placeholder">Select Year</option>
                    {switcherrateyear.map((l) => {
                        return <option key={'currentlendertopup-'+l.value} value={l.value} selected={l.value === this.props.selectedswitcherrateyear}>{l.name}</option>
                    })
                    }
                </select>
            </div>
        );
    }
}